<template>
  <div>
    <div id="body-con">
      <div id="div1">
        <button @click="start=moment(start).add(-7, 'day').format('yyyy-MM-DD');date=start"><svg width="11" height="25" viewBox="0 0 11 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9999 1.32828C10.9999 1.59793 10.9169 1.872 10.7419 2.10629L3.78757 11.5264C3.35685 12.1077 3.35685 12.8923 3.78757 13.4736L10.7419 22.8937C11.1793 23.4861 11.047 24.3149 10.4458 24.7459C9.84456 25.1769 9.00331 25.0465 8.56586 24.4541L1.61154 15.0341C0.492117 13.5178 0.492117 11.4822 1.61154 9.96595L8.56586 0.545849C9.00331 -0.0464977 9.84456 -0.176903 10.4458 0.254097C10.8069 0.512695 10.9999 0.917171 10.9999 1.32828Z" fill="var(--color-pri)"/>
        </svg>
        </button>
        <div @click="selectWeek=!selectWeek">{{moment(start).year()}} , {{moment(start).format('MM/DD')}}~{{moment(start).add(13, 'day').format('MM/DD')}}</div>
        <button @click="start=moment(start).add(7, 'day').format('yyyy-MM-DD');date=start"><svg width="11" height="25" viewBox="0 0 11 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.68732e-06 23.6717C4.69911e-06 23.4021 0.0830087 23.128 0.257988 22.8937L7.21231 13.4736C7.64303 12.8923 7.64303 12.1077 7.21231 11.5264L0.257989 2.10629C-0.179461 1.51394 -0.0471039 0.685096 0.554109 0.254097C1.15532 -0.176902 1.99657 -0.046497 2.43402 0.545851L9.38834 9.96595C10.5078 11.4822 10.5078 13.5178 9.38834 15.0341L2.43402 24.4542C1.99657 25.0465 1.15532 25.1769 0.554108 24.7459C0.192931 24.4873 4.66935e-06 24.0828 4.68732e-06 23.6717Z" fill="var(--color-pri)"/>
        </svg>
        </button>
        <!-- <div class="selectWeek" v-if="selectWeek">
          <div v-for="x in 52" :key="`week-${x}`">{{moment().startOf('week').add(-26 + x, 'week').startOf('week').add(1, 'day').format('yyyy, MM/DD')}}~{{moment().startOf('week').add(-26 + x, 'week').startOf('week').add(14, 'day').format('MM/DD')}}</div>
        </div> -->
      </div>
      <div id="div2">
        <attd-summary v-for="i in 14" :key="`day-${i}`" :index="i"
        :class="date===moment(start).add(i - 1, 'day').format('yyyy-MM-DD')?'selected':''"
        :date="moment(start).add(i - 1, 'day')"
        :data="areasdata"
        @click="date=moment(start).add(i - 1, 'day').format('yyyy-MM-DD')"/>
      </div>
      <div id="div3">
        <div id="div3-head">
          <div>{{date}} ({{wdy[moment(date).weekday()]}})</div>
          <Btns id="btns-attendance" :height="'35px'" :textS="'套用'" v-if="edited.length > 0" @cancel="getdata();edited=[]" @save="apply"/>
        </div>
        <section>
          <div v-for="(area, i) in areas" :key="`area-${i}`">
            <div>
              <div>{{area}}</div>
              <button @click="preedit2=area" class="plusbtn">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="32" height="32" rx="5" fill="var(--color-pri)"/>
                <path d="M15.9998 27C9.92484 27 5 22.0748 5 15.9998C5 9.92516 9.92484 5 15.9998 5C22.0748 5 27 9.92516 27 15.9998C27 22.0748 22.0748 27 15.9998 27ZM15.9998 25.3497C21.1638 25.3497 25.3497 21.1638 25.3497 15.9998C25.3497 10.8359 21.1638 6.64999 15.9998 6.64999C10.8359 6.64999 6.64999 10.8359 6.64999 15.9998C6.64999 21.1638 10.8359 25.3497 15.9998 25.3497ZM16.8248 15.1748H20.1248C20.5805 15.1748 20.9498 15.5442 20.9498 15.9998C20.9498 16.4555 20.5805 16.8248 20.1248 16.8248H16.8248V20.1248C16.8248 20.5805 16.4555 20.9498 15.9998 20.9498C15.5442 20.9498 15.1748 20.5805 15.1748 20.1248V16.8248H11.8749C11.4192 16.8248 11.0499 16.4555 11.0499 15.9998C11.0499 15.5442 11.4192 15.1748 11.8749 15.1748H15.1748V11.8749C15.1748 11.4192 15.5442 11.0499 15.9998 11.0499C16.4555 11.0499 16.8248 11.4192 16.8248 11.8749V15.1748Z" fill="white"/>
                </svg>
              </button>
            </div>
            <div>
              <template v-if="dataselected&&dataselected[area]">
              <StaffBtn v-for="(staff, s) in dataselected[area]?.staffs" :staff="staff" :key="`${area}-staff-${s}`" class="staff" @del="update('staffs', s, area)"/>
              </template>
              <template v-if="dataselected&&dataselected[area]">
              <StaffBtn v-for="(staff, s) in dataselected[area]?.pts" :staff="staff" :key="`${area}-pt-${s}`" class="pts" @del="update('pts', s, area)"/>
              </template>
            </div>
          </div>
        </section>
      </div>
    </div>
    <DialogAbs class="sub" :show="preedit2" v-if="preedit2" :label="`${moment(date).format('yyyy, M/D')}, ${preedit2}`" @close="preedit2=null" width="900" height="700">
    <div class="section">
      <Select1  :defaultValue="department" @input="department=$event" :width="'300px'" :style="{display: 'inline-flex', alignSelf: 'flex-start', height: '52px'}">
        <option v-for="dep in Array.from(new Set([...departments, ...departmentsPT]))" :key="dep" :value="dep">{{dep}}</option>
      </Select1>
        <div class="empsbox">
          <label class="checkbox" :for="us._id"  v-for="(us, i) in emps" :key="`us-${i}`" :class="us.from">
          <input type="checkbox" v-model="preSelected" :id="us._id" :value="us">
          {{us.name}}
          </label>
        </div>
        <div class="btns" :style="{margin: 'auto', height: '35px', minHeight: '35px'}">
          <button @click="clear">清除重選</button>
          <button :style="{backgroundColor: 'var(--color-confirm)'}" @click="addstaff">確認</button>
        </div>
    </div>
    </DialogAbs>
  </div>
</template>

<script>
import Btns from '../../components/btn/btns.vue'
import StaffBtn from '../../components/attendance/staffbtn.vue'
import attdSummary from '../../components/attendance/summary.vue'
import Select1 from '../../components/select.vue'
import DialogAbs from '../../components/dialognoPadding2.vue'
import { getapi, putapi } from '../../store/fetch'
const wdy = ['日', '一', '二', '三', '四', '五', '六', '日']
export default {
  components: {
    Btns,
    Select1,
    DialogAbs,
    attdSummary,
    StaffBtn
  },
  data () {
    return {
      selectWeek: false,
      preedit2: null,
      wdy,
      edit: null,
      start: this.moment().startOf('week').add(1, 'day').format('yyyy-MM-DD'),
      areas: [],
      date: this.moment().startOf('week').add(1, 'day').format('yyyy-MM-DD'),
      // 選項內容
      departments: [],
      departmentsPT: [],
      department: '營運二部',
      emps: [],
      preSelected: [],
      areasdata: {},
      edited: [],
      dataselected: {}
    }
  },
  async mounted () {
    this.areas = await getapi('selections/cmcp_areas')
    const departments = await getapi('users/department')
    this.departments = departments.filter(e => e)
    const departmentsPT = await getapi('users/department/PT')
    this.departmentsPT = departmentsPT.filter(e => e)
    await this.getdata()
    await this.getemps()
  },
  methods: {
    async apply () {
      Promise.all(this.edited.map(async (area) => {
        const a = await putapi('cmcpAttendance', {
          date: this.moment(this.date).startOf('day').toISOString(),
          area: area,
          staffs: this.dataselected[area].staffs.map(e => e._id),
          pts: this.dataselected[area].pts.map(e => e._id)
        })
        if (this.areasdata[this.date]) {
          this.areasdata[this.date][area] = { pts: a.pts, staffs: a.staffs }
        } else {
          this.areasdata[this.date] = { [area]: { pts: a.pts, staffs: a.staffs } }
        }
      })).then(() => {
        this.edited = []
      })
    },
    clear () {
      this.preSelected = []
    },
    update (key, index, area) {
      console.log(key, index, area, this.dataselected[area])
      this.dataselected[area][key].splice(index, 1)
      if (!this.edited.includes(area)) {
        this.edited.push(area)
      }
    },
    async addstaff () {
      const a = await putapi('cmcpAttendance', {
        date: this.moment(this.date).startOf('day').toISOString(),
        area: this.preedit2,
        staffs: this.preSelected.filter(e => e.from === 'users').map(e => e._id),
        pts: this.preSelected.filter(e => e.from === 'pts').map(e => e._id)
      })
      console.log('addstaff', this.areasdata[this.date], this.preedit2, { pts: a.pts, staffs: a.staffs })
      if (this.areasdata[this.date]) {
        this.areasdata[this.date][this.preedit2] = { pts: a.pts, staffs: a.staffs }
      } else {
        this.areasdata[this.date] = { [this.preedit2]: { pts: a.pts, staffs: a.staffs } }
      }
      this.dataselected = this.areasdata[this.date] ? JSON.parse(JSON.stringify(this.areasdata[this.date])) : {}
      this.preedit2 = null
    },
    async getemps () {
      const emps = await getapi(`users/emps?department=${this.department}`)
      const PTs = await getapi(`users/emps/PT?department=${this.department}`)
      this.emps = [...emps.map(e => {
        return {
          ...e, from: 'users'
        }
      }), ...PTs.map(e => {
        return {
          ...e, from: 'pts'
        }
      })]
    },
    async getdata () {
      console.log(`cmcpAttendance/range?${new URLSearchParams({
        start: this.moment(this.start).startOf('day').toISOString(),
        duration: 14
      })}`)
      this.areasdata = await getapi(`cmcpAttendance/range?${new URLSearchParams({
        start: this.moment(this.start).startOf('day').toISOString(),
        duration: 14
      })}`)
      this.dataselected = this.areasdata[this.date] ? JSON.parse(JSON.stringify(this.areasdata[this.date])) : {}
    }
  },
  watch: {
    preedit2 () {
      if (this.preedit2 === null) {
        this.preSelected = []
      } else {
      }
    },
    start () {
      this.getdata()
    },
    date () {
      this.dataselected = this.areasdata[this.date] ? JSON.parse(JSON.stringify(this.areasdata[this.date])) : {}
    },
    department () {
      this.getemps()
    }
  }

}
</script>

<style lang="scss">
#attendance {
  * {
    box-sizing: border-box;
  }
  #btns-attendance.btns > button {
    height: 35px!important;
  }
  .sub {
    label {
      display: inline-flex!important;
    }
  }
  .dialogbox > div > .empsbox {
    margin: 0!important;
    padding: 0!important;
  }
}
</style>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.selectWeek {
  border-radius: 5px;
  overflow-y: auto;
  position: fixed;
  top: 160px;
  width: 330px;
  z-index: 20;
  background-color: var(--color-checked);
  color: #FFFFFF!important;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 600px;
  letter-spacing: .1em;
  gap: 1px;
  border: 1px solid var(--color-checked);
  flex:1;
  &>div{
    flex:1;
    min-height: 40px;
    background-color: #FFFFFF;
    width: calc(100% - 2px);
    color: var(--color-checked);
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
#btns-attendance {
  position: absolute;
  right: 27px;
}
.section {
  max-height: 600px;
  padding: 20px 30px;
  display: flex!important;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  gap: 25px!important;
  margin-inline: 0!important;
  margin-block: 21px 31px!important;
}
.btns {
  display: flex!important;
  align-items: center;
  justify-content: center;
  gap: 28px;
  button {
    width: 100px;
    height: 35px;
    background: #B8B8B8;
    border-radius: 20px;
    border: none;
    font-weight: 400;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
  }
}
.empsbox {
  display: flex;
  flex-wrap: wrap;
  gap: 25px 35px!important;
  overflow-y: auto;
}
label.checkbox {
  width: 180px;
  height: 49px;
  // border: 1px solid var(--color-checked);
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  gap: 10px;
  letter-spacing: 2px;
  font-size: 20px;
  &.users {
    background-color: var(--color-infobox);
  }
  &.pts {
    background-color: #FFE4E4E5;
  }
}
input[type=checkbox] {
  width: 30px;
  height: 30px;
  accent-color: var(--color-checked);
  position: relative;
  border-radius: 5px;
  overflow: hidden;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid var(--color-checked);
  }
}
.plusbtn {
  width: 32px;
  height: 32px;
  background-color: transparent;
}
#div3 {
  width: 100%;
  border: 1px solid #DADADA;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  margin-top: 35px;
  border-radius: 5px;
  section {
    width: 100%;
    display: flex;
    &>div{
      position: relative;
      flex:1;
      min-height: 422px;
      &:not(:last-child) {
        border-right: 1px solid #DADADA;
      }
      &>div {
        min-height: 2em;
        color: var(--color-checked);
      }
      &>div:nth-child(1){
        height: 60px;
        font-weight: 500;
        font-size: 18px;
        line-height: 25px;
        text-align: center;
        letter-spacing: 0.1em;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #DADADA;
        &>div{flex:1;}
        padding-inline: 20px;
      }
      &:nth-child(odd)>div:nth-child(1) {
        background-color: var(--color-infobox);
      }
      &>div:nth-child(2) {
        padding: 15px 28px;
        display: flex;
        flex-direction: column;
        gap: 15px;
      }
    }
  }
}
#div3-head {
  background-color: var(--color-checked);
  color: #FFFFFF;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px 5px 0 0;
  position: relative;
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
  letter-spacing: 0.1em;
}
#div2 {
  margin-top: 23px;
  display: flex;
  border: 1px solid #DADADA;
  border-radius: 5px;
}
#div1{
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  &>div{
    min-width: 290px;
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-checked);
  }
  button {
    background-color: transparent;
  }
}
#body-con {
  padding-block: 25px;
  padding-inline: 23px;

}
</style>
